import { render } from "./TokenInput.vue?vue&type=template&id=6c9b1ec4"
import script from "./TokenInput.vue?vue&type=script&lang=ts"
export * from "./TokenInput.vue?vue&type=script&lang=ts"

import "./TokenInput.vue?vue&type=style&index=0&id=6c9b1ec4&lang=css"
script.render = render

export default script